import { axiosInstance } from '../AxiosDefaults';

export const getOneLecturer = (id: string): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_SITE;
  return axiosInstance.get(`${`/lecturers`}/${id}`, {
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-secretid': secretId,
      'x-clientid': clientId
    }
  });
};
